import { createApi } from "@reduxjs/toolkit/query/react";
import { Workspace } from "../../models/workspace";
import { axiosBaseQuery, QueryArg } from "../axiosConfig";
import { RequestMethod } from "../enum";
import { ServerError } from "../types";
import { usersApi } from "../users";
import { transformWorkspace } from "./helpers";

const getWorkspacesEndpoint = (): QueryArg => ({ url: "", method: RequestMethod.GET });

const getWorkspaceEndpoint = (id: string): QueryArg => ({ url: `/${id}`, method: RequestMethod.GET });

export const workspaceApi = createApi({
  reducerPath: "workspaceApi",
  baseQuery: axiosBaseQuery<any>({
    baseUrl: "/workspaces",
  }),
  tagTypes: ["Workspaces", "Workspace"],
  endpoints: (build) => ({
    getWorkspaces: build.query<Workspace[], void>({
      queryFn: async (args, { dispatch }, extraOptions, baseQuery) => {
        try {
          const response = await baseQuery(getWorkspacesEndpoint());
          if (response?.data?.workspaces) {
            let workspaces: Workspace[] = [...(response?.data?.workspaces ?? [])];
            const users = await dispatch(usersApi.endpoints.getUsers.initiate()).unwrap();
            workspaces = workspaces
              .map((workspace) => {
                return transformWorkspace(workspace, users);
              })
              .sort((a, b) => a.name.localeCompare(b.name));
            return { data: workspaces };
          }
          return { error: response.error };
        } catch (error) {
          return { error: error as ServerError };
        }
      },
      providesTags: ["Workspaces"],
    }),
    getWorkspace: build.query<Workspace, string>({
      queryFn: async (id, { getState, dispatch }, extraOptions, baseQuery) => {
        try {
          const response = await baseQuery(getWorkspaceEndpoint(id));
          const workspace: Workspace = response?.data?.workspace;
          const users = await dispatch(usersApi.endpoints.getUsers.initiate()).unwrap();
          if (workspace) {
            return { data: transformWorkspace(workspace, users) };
          }
          return { error: response?.error };
        } catch (error) {
          return { error: error as ServerError };
        }
      },
      providesTags: (result, error, id) => [{ type: "Workspace", id }],
    }),
  }),
});
